var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4277 10.1157V9.69947C18.4509 5.00582 14.6821 1.1908 10.0116 1.1908C5.34104 1.1908 1.57225 5.02895 1.57225 9.72259V10.1388C0.624278 10.6243 0 11.5954 0 12.7052V15.9422C0 17.5145 1.2948 18.8093 2.86705 18.8093H5.15607C5.82659 18.8093 6.35838 18.2544 6.35838 17.607V11.0174C6.35838 10.3469 5.80347 9.81507 5.15607 9.81507H4V9.69947C4 6.34687 6.68208 3.59542 10.0116 3.59542C13.341 3.59542 16.0231 6.34687 16.0231 9.69947V9.81507H14.8671C14.1965 9.81507 13.6647 10.37 13.6647 11.0174V17.5839C13.6647 18.2544 14.2197 18.7862 14.8671 18.7862H17.1329C18.7052 18.7862 20 17.4914 20 15.9191V12.6821C20 11.5723 19.3757 10.6012 18.4277 10.1157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.cb73f808b3b6f16d4416ac031fd675b2.svg";
export { ForwardRef as ReactComponent };